import {clickEvent, fireChangeEvent} from "../../../../webpack/modules/events";
import {isDesktop} from "../../../../webpack/modules/devices";
import {fadeIn, fadeOut} from "../../../../webpack/modules-optimized/element-visibility";
import {
    hideOffcanvasByDomObject,
    showOffcanvasByDomObject
} from "../../../../webpack/modules-optimized/offcanvas";
import {
    getProductConfigurationViews, updateConfigurationButtons,
    updateConfigurationStepPoints, updateOpenConfigurationButtons
} from "../../../../webpack/modules-optimized/product-list";
import {initTomSelectQuantity} from "../../../../webpack/modules-optimized/tomselect";

updateOpenConfigurationButtons();

clickEvent('#product-list-page .btn-configure-product', true, async function(element, event) {
    event.preventDefault();
    let productId = element.closest('.product').dataset.productId;
    let productData = null;
    let container = isDesktop() ? element.closest('.product') : document.querySelector('#product-list-page .row');
    let currentConfigurationContainerOpened = document.querySelector('#product-list-page .product-configuration.open');
    let containerConfigurationMain = isDesktop() ? element.closest('.product').querySelector('.product-configuration-main.desktop-product-configuration') : document.querySelector('#product-list-page .product-configuration-main.mobile-product-configuration');

    try {
        productData = element.closest('.product a').dataset.analyticsExtra || null;
    } catch (e) {
        productData = null
    }

    if (isDesktop()) {
        if (currentConfigurationContainerOpened) await fadeOut(currentConfigurationContainerOpened);
        fadeIn(containerConfigurationMain, 150, 'flex');
    } else {
        if (currentConfigurationContainerOpened) hideOffcanvasByDomObject(containerConfigurationMain);
        showOffcanvasByDomObject(containerConfigurationMain);
    }

    showLoader(containerConfigurationMain);
    document.querySelectorAll('#product-list-page .product-configuration:not(.product-configuration-main)').forEach(function(configuration) {
        configuration.remove();
    });

    let [mainView, views] = await getProductConfigurationViews(productId, productData);

    if (mainView) {
        containerConfigurationMain.querySelector('.body').innerHTML = mainView;
        containerConfigurationMain.dataset.productId = productId;
        if (productData) {
            productData = JSON.parse(productData);
            containerConfigurationMain.dataset.productReference = productData['ref'] || '';
            containerConfigurationMain.dataset.productType = productData['type'] || '';
        } else {
            containerConfigurationMain.dataset.productReference = '';
            containerConfigurationMain.dataset.productType = '';
        }
    }
    if (views) initConfigurationViews(views, container, productId);

    hideLoader(containerConfigurationMain);
    if (currentConfigurationContainerOpened) currentConfigurationContainerOpened.classList.remove('open');
    containerConfigurationMain.classList.add('open');
    updateConfigurationStepPoints();
    updateConfigurationButtons();
});

function showLoader(container)
{
    container.querySelector('.body').innerHTML = `
    <div class="product-configuration-loader d-flex bg-white w-100 h-100 align-items-center justify-content-center z-index-inherit">
        <div class="spinner-border"></div>
    </div>`;
}

function hideLoader(container)
{
    let loader = container.querySelector('.product-configuration-loader');
    if (!loader) return;
    loader.remove();
}

function initConfigurationViews(views, container, productId)
{
    views.forEach(function (view) {
        let configurationContainer = document.createElement('div');
        configurationContainer.innerHTML = getConfigurationContainerHtml();
        configurationContainer = configurationContainer.firstChild;
        configurationContainer.classList.add(`product-configuration-${view.type}`);
        configurationContainer.dataset.optionType = view.optionType;
        configurationContainer.dataset.type = view.type;
        configurationContainer.dataset.configurationNumber = view.configurationNumber;
        configurationContainer.dataset.productId = productId;
        configurationContainer.dataset.completed = view.defaultValue && view.defaultValue !== '' ? 'true' : 'false';
        configurationContainer.innerHTML = view.html;
        configurationContainer.querySelector('.body').dataset.type = view.type;
        configurationContainer.querySelector('.body').classList.add('options');

        if (!isDesktop()) {
            configurationContainer.querySelector('.header').classList.add('offcanvas-header');
            configurationContainer.querySelector('.body').classList.add('offcanvas-body');
            configurationContainer.querySelector('.footer').classList.add('offcanvas-footer');
        }

        container.appendChild(configurationContainer);
        if (view.type === 'size') {
            initTomSelectQuantities();
            initTomSelectEvents();
        }
    });
}

function getConfigurationContainerHtml()
{
    if (isDesktop()) {
        return `<div class="desktop-product-configuration product-configuration position-absolute w-100 h-85 start-0 bottom-0 z-index-lower bg-white px-2" style="display: none !important;"></div>`;
    } else {
        return `<div class="offcanvas offcanvas-bottom mobile-product-configuration product-configuration"></div>`;
    }
}

function initTomSelectQuantities()
{
    if(document.querySelectorAll('#product-list-page .product-configuration[data-option-type="multiple-selectable"] .ts-wrapper').length > 0) return;
    document.querySelectorAll('#product-list-page .product-configuration[data-option-type="multiple-selectable"] .select-quantity').forEach(function(quantity) {
        if (quantity.tomselect) return;

        let tomSelect = initTomSelectQuantity(quantity);
        tomSelect.on('dropdown_close', function() {
            let wrapper = tomSelect.wrapper;
            let size = wrapper.closest('.size');
            let input = document.querySelector(`input[name="size"][id="${size.htmlFor}"]`);
            let quantity = tomSelect.getValue();

            if (!input) return;

            input.checked = quantity > 0;
            input.dataset.quantity = quantity;
            fireChangeEvent(input, true);
        });
    });
}

function initTomSelectEvents()
{
    document.querySelectorAll('#product-list-page .product-configuration-size[data-option-type="multiple-selectable"] .size-box-container:not(.no-block-open)').forEach(function (element) {
        element.addEventListener('mouseup', function (event) {
            let target = event.target;
            if (target.classList.contains('.ts-wrapper')) return;

            event.preventDefault();
            event.stopPropagation();
            let tsOpen = element.dataset.tsopen || 'false';
            let tsClick = element.dataset.tsclick || 'false';
            let quantitySelector = element.querySelector('.quantity-selector');
            if (tsOpen === 'false' && tsClick === 'false' && quantitySelector) {
                quantitySelector.tomselect.focus();
                element.dataset.tsclick = 'true';
            } else {
                element.dataset.tsclick = 'false';
            }

            return false;
        }, false);
    });
}